export default __webpack_public_path__ + "static/media/add.8b3fd51a.svg";